export default __webpack_public_path__ + "static/media/permission_mobile.18dc5fab.svg";